module.exports = __webpack_public_path__ + "img/poop.e015b433.svg";